<template lang="pug">
  div(class="uploaded-file mt-4")
    div(class="d-flex align-center justify-space-between")
      div(class="d-flex align-center")
        div(
          class="uploaded-file__icon"
          :class="{ 'mr-2': xsDevice, 'mr-4': !xsDevice }"
        )
          v-img(
            :src="require('~/assets/images/file.png')"
            :max-width="xsDevice ? '24px' : '32px'"
            position="center"
            class="my-0 mx-auto"
          )
        div(class="uploaded-file__content")
          h4(class="text-14px dark") {{ fileName }}
          span(
            v-if="fileSize"
            class="text-12px light mr-3"
          ) {{ formatBytes(fileSize) }}
          span(class="text-12px light uploaded-file__status") {{ $t('Downloaded') }}
      div(class="uploaded-file__actions")
        v-btn(
          v-if="canDelete"
          @click.stop="removeFile"
          color="#FFF1F4"
          icon
          class="uploaded-file__btn"
        )
          e-svg-icon(name="danger-trash")
</template>

<script>
import prettyBytes from 'pretty-bytes'
import responsive from '~/mixins/pages/responsive'

export default {
  name: 'EFileUploaded',
  mixins: [responsive],
  props: {
    fileName: {
      type: String,
      default: null
    },
    fileSize: {
      type: Number,
      default: null
    },
    canDelete: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatBytes(bytes) {
      return prettyBytes(bytes)
    },
    removeFile() {
      this.$emit('remove')
    }
  }
}
</script>

<style scoped lang="scss">
.uploaded-file {
  border: 1px solid #cdcdcd;
  border-radius: 12px;
  padding: 12px;

  &:not(:last-child) {
    margin-bottom: 12px;
  }

  &__icon {
    width: 48px;
    height: 48px;

    background: $background-gray;
    border-radius: 8px;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__status {
    color: #039855;
  }

  &__btn {
    width: 32px;
    height: 32px;
    border-radius: 8px !important;
    background: #fff1f4 !important;
  }
}
</style>
